module.exports = __webpack_public_path__ + "static/media/appointment.c2e8b7ae.svg";